// Multi-territory Exchange Rates admin config.
// Column + base-currency option definitions driving the Exchange Rates tab.

import { GLOBAL_CONSTANTS } from '@/constants/globalConstants'

export interface MTExchangeRateColumn {
  id: string
  label: string
}

// Grid columns for the exchange-rates table. The rate column label is dynamic
// (reflects the selected base currency), so it is overridden at render time.
export const MT_EXCHANGE_RATE_COLUMNS: MTExchangeRateColumn[] = [
  {
    id: 'country',
    label: 'Country',
  },
  {
    id: 'reportingCurrency',
    label: 'Reporting currency',
  },
  {
    id: 'exchangeRate',
    label: GLOBAL_CONSTANTS.MT_ADMIN_EXCHANGE_RATES_RATE_COLUMN,
  },
]

export const MT_DEFAULT_BASE_CURRENCY = 'USD'
